<div class="cd-wrapper">
  <!--
    Hidden sizer: renders every option label (plus the placeholder) at full width
    so the wrapper naturally sizes itself to the longest text.
    height:0 + overflow:hidden keeps it invisible and removes it from the visual flow.
    When any option has an icon, include the icon glyph so sizing stays accurate.
  -->
  <div class="cd-sizer" aria-hidden="true">
    <span>
      @if (hasIcons) {
      <i class="fa fa-fw cd-sizer__icon-placeholder"></i>
      {{ placeholder }}
      }
    </span>
    <span *ngFor="let opt of normalizedOptions">
      @if (hasIcons) {
      <i [class]="(opt.icon || 'fa fa-fw') + ' cd-sizer__icon-placeholder'"></i>
      }
      {{ opt.label }}
    </span>
  </div>

  <!-- Trigger -->
  <div
    class="cd-trigger"
    (click)="toggle()"
    [class.cd-trigger--open]="isOpen"
    [class.cd-trigger--placeholder]="value === null || value === undefined"
    [class.cd-trigger--disabled]="isDisabled"
    [class.cd-trigger--naked]="naked"
    [attr.aria-disabled]="isDisabled"
  >
  @if(selectedIcon) {
    <i  [class]="selectedIcon + ' cd-trigger__icon'"></i>
  }
    <span class="cd-trigger__label">{{ selectedLabel }}</span>

    <!-- Clear button: only when clearable=true, a value is selected, and not disabled -->
    <button data-testid="auto-app-custom-dropdown-button-1"
      *ngIf="clearable && value !== null && value !== undefined && !isDisabled"
      class="cd-trigger__clear"
      type="button"
      title="Clear selection"
      (click)="clearSelection($event)"
    >
      <i class="fa fa-times"></i>
    </button>

    <span class="cd-trigger__arrow" [class.cd-trigger__arrow--open]="isOpen">
      <i class="fa fa-chevron-down"></i>
    </span>
  </div>

  <!-- Dropdown panel -->
  <div class="cd-panel" *ngIf="isOpen" [class.cd-panel--align-right]="panelAlignRight">

    <!-- Filter input: only when filterable=true -->
    <div class="cd-panel__filter" *ngIf="filterable">
      <i class="fa fa-search cd-panel__filter-icon"></i>
      <input data-testid="auto-app-custom-dropdown-input-1"
        class="cd-panel__filter-input"
        type="text"
        [placeholder]="filterPlaceholder"
        [(ngModel)]="filterQuery"
        (click)="$event.stopPropagation()"
        autocomplete="off"
      />
    </div>

    <!-- Virtual-scroll viewport: renders only the rows currently in view -->
    <cdk-virtual-scroll-viewport
      *ngIf="visibleOptions.length > 0"
      class="cd-panel__options"
      [itemSize]="rowHeight"
      [style.height.px]="viewportHeight"
    >
      <div
        *cdkVirtualFor="let option of visibleOptions; trackBy: trackByValue"
        class="cd-panel__option"
        [class.cd-panel__option--selected]="option.value === value"
        (click)="select(option)"
      >
        <i
          *ngIf="option.icon || hasIcons"
          [class]="(option.icon || 'fa fa-fw') + ' cd-panel__option-icon'"
        ></i>
        {{ option.label }}
      </div>
    </cdk-virtual-scroll-viewport>

    <!-- Empty state: shown outside viewport when no options match the filter -->
    <div class="cd-panel__empty" *ngIf="visibleOptions.length === 0">
      No options found
    </div>
  </div>
</div>
